import PropTypes from 'prop-types';

/**
 * Text input component
 * 
 * @param {object} props
 * @param {string} props.id - component ID
 * @param {string} props.placeholder - placeholder text for input
 * @param {string} props.label - label text that appears above the input
 * @param {boolean} props.required - true if input is required, false otherwise
 * @param {number} props.charLimit - maximum number of characters that can be input
 * @param {string} props.value - the current value held in the input (used with useState)
 * @param {Function} props.setValue - function for setting some state to the current input value
 * @param {boolean} props.isOther - true if the text field is an "Other" field on the registration form
 */
const TextInput = ({ id, placeholder, label, required, charLimit = 80, value, setValue, isOther }) => {
    return (
        <>
            {label && 
                <label className="input-label" htmlFor={id}>
                    {(required && !isOther) ? `${label} *` : label}
                </label>
            }
            <input
                type="text" 
                id={id}
                name={id}
                placeholder={placeholder}
                maxLength={charLimit}
                required={required}
                value={value}
                onChange={setValue}
            />

        </>
    );
};

TextInput.propTypes = {
    id: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    charLimit: PropTypes.number,
    value: PropTypes.string,
    setValue: PropTypes.func,
    isOther: PropTypes.bool,
};

export default TextInput;